import { ADD_TO_ANY_SHARE_SCRIPT_STATIC_URL } from '../constants/addToAny.constants';
import { documentService, windowService } from './window.utils';

export const addToAnyScript = () => {
  const addthisScript = documentService()?.createElement?.('script');
  addthisScript.setAttribute('src', ADD_TO_ANY_SHARE_SCRIPT_STATIC_URL);
  const shareContentScript = documentService()?.querySelector?.(`[src="${ADD_TO_ANY_SHARE_SCRIPT_STATIC_URL}"]`);
  if (documentService()?.body && !shareContentScript) documentService()?.body?.appendChild?.(addthisScript);
  else windowService()?.a2a?.init_all?.();
};
